export const companyContractDto = {
  contractInfo: {
    clientInfo: {
      // 고객사측 정보
      companyName: "",
      contactPerson: "",
      contactNumber: "",
      email: "",
    },
    headInfo: {
      // 본사측 정보
      companyName: "(주)통인익스프레스",
      contactPerson: "",
      contactNumber: "",
      email: "",
    },
    detailInfo: {
      title: "", // 제목
      totalEmployees: "", // 직원수
      workDate1: "", // 작업일정2
      workDate2: "", // 작업일정1
      contractDate: "", // 계약날짜
      subCondition: "", // 부대조건
      departureAddress1: "", // 출발주소1
      departureAddress1Detail: "", // 출발주소1상세
      destinationAddress1: "", // 도착주소1
      destinationAddress1Detail: "", // 도착주소1상세
      departureAddress2: "", // 출발주소2
      departureAddress2Detail: "", // 출발주소2상세
      destinationAddress2: "", // 도착주소2
      destinationAddress2Detail: "", // 도착주소2상세
      departureAddress3: "", // 출발주소3
      departureAddress3Detail: "", // 출발주소3상세
      destinationAddress3: "", // 도착주소3
      destinationAddress3Detail: "", // 도착주소3상세
      departureZipCode1: "", // 출발주소1 우편번호
      destinationZipCode1: "", // 출발주소1 우편번호
      departureZipCode2: "", // 출발주소2 우편번호
      destinationZipCode2: "", // 출발주소2 우편번호
      departureZipCode3: "", // 출발주소3 우편번호
      destinationZipCode3: "", // 출발주소3 우편번호
      workCondition1: "", // 작업조건1
      workCondition2: "", // 작업조건2
    },
  },
  chargeList: [
    {
      id: 1,
      text: "1page",
      roomList: [
        {
          id: 1,
          name: "사무실",
          type: 1, // 공간 타입 1.사무실 2.회의실 3.임원실 4.문서고 5.창고 6.탕비실 7.전산실 8.기타(사용자정의)
          typeName: "office",
          quantity: 0, // 각 공간의 수량 합계
          cbm: 0, // 각 공간의 cbm 합계
          itemList: [],
        },
      ],
      name: "", // 품명
      category: "", // 작업구분
      contents: "", // 작업내용
      unit: "", // 단위
      remark: "", // 비고
      total: "", // 5. 합계[1+2+3+4]
      expenses: "", // 6.공과잡비
      commonCost: "", // 7.일반관리비
      profit: "", // 8.이윤
      totalServiceCost: "", // 8.총 용역원가
      quotedPrice: "", // 9. 견적가
      expensesRate: "5", // 공과잡비비율
      commonCostRate: "10", // 일반관리비비율
      profitRate: "10", //이윤 비율
      materialCost: {
        title: "재료비",
        total: "",
        List: [
          {
            id: 0,
            name: "포장용 박스",
            spec: "450*430*400",
            unit: "장",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 1,
            name: "에어캡",
            spec: "50cm*50m",
            unit: "개",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 2,
            name: "포장용 테이프",
            spec: "50mm*50m",
            unit: "개",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 3,
            name: "PC 박스",
            spec: "600*410*470",
            unit: "장",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 4,
            name: "바구니",
            spec: "610*380*320",
            unit: "개",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 5,
            name: "청랩",
            spec: "50cm*500m",
            unit: "롤",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 6,
            name: "물품표",
            spec: "",
            unit: "개",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 7,
            name: "보양자재",
            spec: "",
            unit: "장",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 8,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 9,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
        ],
      },
      movingCost: {
        title: "차량비",
        total: "",
        List: [
          {
            id: 0,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 1,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 2,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 3,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 4,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
        ],
      },
      laborCost: {
        title: "노무비",
        total: "",
        List: [
          {
            id: 0,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 1,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 2,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 3,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 4,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
        ],
      },
      ectCost: {
        title: "기타",
        total: "",
        List: [
          {
            id: 0,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 1,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 2,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 3,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 4,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
        ],
      },
    },
  ],
};
